export const COOKIE_NAME = 'lgpd-cookie-v2';
export const COOKIE_VERSION = 7;
export const COOKIE_MAX_AGE = 31536000; // 365 * 24 * 60 * 60;

const uniqueValues = (values = []) =>
  values.filter((value, index, array) => array.indexOf(value) === index);

const parseEnvList = (envValue) => {
  if (!envValue) return [];

  const normalizedEnvValue = String(envValue).trim();
  if (!normalizedEnvValue) return [];
  if (/^__.*__$/.test(normalizedEnvValue)) return [];

  if (normalizedEnvValue.startsWith('[')) {
    try {
      const parsed = JSON.parse(normalizedEnvValue);
      if (Array.isArray(parsed)) {
        return parsed.map((value) => String(value).trim()).filter(Boolean);
      }
    } catch (error) {
      // Fallback para formato simples com separador por vírgula.
    }
  }

  return normalizedEnvValue
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
};

// Domínios hardcoded padrão
const DEFAULT_GROUP_DOMAINS = {
  performance: [
    '//www.google-analytics',
    '//www.googletagmanager',
    'estatisticas.presidencia.gov.br',
    'matomo.iec.gov.br',
    'matomo.pf.gov.br',
  ],
  thirdParty: [
    '//www.youtube',
    '//youtu.be',
    '//sipec.centralit',
    '//cse.google',
    '//www.doubleclick',
    '//www.google.com',
    '//connect.facebook',
    '//www.instagram.com',
    '//platform.instagram.com',
    '//platform.twitter.com',
    '//www.facebook.com',
    '//open.spotify.com',
    '//siasg.centralit',
    '//chatbotatendimento-producao.azurewebsites.net',
    '//servicos.dnit.gov.br/chatbot/chat',
    'webchat.botframework.com',
    '//www.linkedin.com',
    'connect.facebook.net',
    'static.ads-twitter.com',
    'snap.licdn.com',
    '//vimeo.com',
    '//view.genially.com',
  ],
  // Também seve para domínios que geram cookies, mas não precisam de consentimento.
  noConsentUrls: [
    '//www.gov.br',
    '//www.youtube-nocookie.com',
    '//dd-publico.serpro.gov.br/single',
  ],
};

const RUNTIME_ENV_GROUP_DOMAINS = {
  performance:
    process.env.RAZZLE_LGPD_PERFORMANCE_DOMAINS ||
    '',
  thirdParty:
    process.env.RAZZLE_LGPD_THIRD_PARTY_DOMAINS ||
    '',
  noConsentUrls:
    process.env.RAZZLE_LGPD_NO_CONSENT_URLS || '',
};

const ENV_GROUP_DOMAINS = {
  performance: parseEnvList(RUNTIME_ENV_GROUP_DOMAINS.performance),
  thirdParty: parseEnvList(RUNTIME_ENV_GROUP_DOMAINS.thirdParty),
  noConsentUrls: parseEnvList(RUNTIME_ENV_GROUP_DOMAINS.noConsentUrls),
};

const BASE_GROUP_DOMAINS = {
  performance: uniqueValues([
    ...DEFAULT_GROUP_DOMAINS.performance,
    ...ENV_GROUP_DOMAINS.performance,
  ]),
  thirdParty: uniqueValues([
    ...DEFAULT_GROUP_DOMAINS.thirdParty,
    ...ENV_GROUP_DOMAINS.thirdParty,
  ]),
  noConsentUrls: uniqueValues([
    ...DEFAULT_GROUP_DOMAINS.noConsentUrls,
    ...ENV_GROUP_DOMAINS.noConsentUrls,
  ]),
};

/**
 * Mescla os domínios hardcoded com os domínios dinâmicos da API
 * @function mergeGroupDomains
 * @param {Array} domainsWithConsent - Domínios que requerem consentimento (da API)
 * @param {Array} domainsWithoutConsent - Domínios que não requerem consentimento (da API)
 * @returns {Object} Objeto com os domínios mesclados
 */
export const mergeGroupDomains = (
  domainsWithConsent = [],
  domainsWithoutConsent = [],
) => {
  return {
    performance: BASE_GROUP_DOMAINS.performance,
    thirdParty: [
      ...BASE_GROUP_DOMAINS.thirdParty,
      ...domainsWithConsent,
    ].filter((v, i, a) => a.indexOf(v) === i), // Remove duplicatas
    noConsentUrls: [
      ...BASE_GROUP_DOMAINS.noConsentUrls,
      ...domainsWithoutConsent,
    ].filter((v, i, a) => a.indexOf(v) === i), // Remove duplicatas
  };
};

// Exporta os domínios padrão para compatibilidade retroativa
export const GROUP_DOMAINS = BASE_GROUP_DOMAINS;

export const PERFORMANCE_COOKIES_PREFIX = ['_ga', '_gid', '_gat', '_pk_'];
